"use strict";
var moment = require("moment");
var constants_1 = require("./constants");
function tripLengthValidator(departureDate, maxTripLength) {
    return function (control) {
        var begin = moment(departureDate, constants_1.Constants.DATE_PARSE_FORMAT);
        var end = moment(control.value, constants_1.Constants.DATE_PARSE_FORMAT);
        var tripLength = end.diff(begin, 'days') + 1;
        if (tripLength > maxTripLength) {
            return { 'maxTripLength': tripLength };
        }
        return null;
    };
}
exports.tripLengthValidator = tripLengthValidator;
function tripLengthValidatorNowWithMinimumChecking(departureDate, maxTripLength, minTripLength) {
    return function (control) {
        var begin = moment(departureDate, constants_1.Constants.DATE_PARSE_FORMAT);
        var end = moment(control.value, constants_1.Constants.DATE_PARSE_FORMAT);
        var tripLength = end.diff(begin, 'days') + 1;
        if (tripLength > maxTripLength) {
            return { 'maxTripLength': tripLength };
        }
        if (tripLength < minTripLength) {
            return { 'minTripLength': tripLength };
        }
        return null;
    };
}
exports.tripLengthValidatorNowWithMinimumChecking = tripLengthValidatorNowWithMinimumChecking;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/validators/trip-length.validator.js